'use client';

import { c as _c } from "react/compiler-runtime";
import { CommandItem } from '@repo/ui/components';
import { Container } from '@repo/ui/icons';
import { useDebouncedValue } from '@repo/tanstack/pacer';
import { useRouter } from 'next/navigation';
import type { CommandWorkflowContext } from '@repo/shortcuts/command';
import { useCmdkLoads } from './_hooks/use-cmdk-loads.ts';
import { CmdkSearchHost } from './cmdk-search-host.tsx';
import { LoadResultRow } from './load-result-row.tsx';
export const LoadListRender = t0 => {
  const $ = _c(22);
  const {
    context
  } = t0;
  const {
    push
  } = useRouter();
  let t1;
  if ($[0] !== context.search) {
    t1 = context.search.trim();
    $[0] = context.search;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const search = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      wait: 200
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [debouncedSearch] = useDebouncedValue(search, t2);
  const {
    data: loads,
    isLoading
  } = useCmdkLoads(debouncedSearch);
  if (!search) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <CommandItem disabled={true} forceMount={true} value="__cmdk-instruction-loads__"><Container className="size-4 shrink-0 text-muted-foreground" />Type to search loads</CommandItem>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  if ($[4] !== context.search) {
    t3 = <CmdkSearchHost search={context.search} />;
    $[4] = context.search;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const lifecycleItem = t3;
  if (search !== debouncedSearch || isLoading) {
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <CommandItem disabled={true} forceMount={true} value="__cmdk-loading-loads__"><Container className="size-4 shrink-0 animate-spin text-muted-foreground" />Searching loads...</CommandItem>;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== lifecycleItem) {
      t5 = <>{lifecycleItem}{t4}</>;
      $[7] = lifecycleItem;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  if (!loads || loads.length === 0) {
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <CommandItem disabled={true} forceMount={true} value="__cmdk-empty-loads__"><Container className="size-4 shrink-0 text-muted-foreground" />No loads found.</CommandItem>;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== lifecycleItem) {
      t5 = <>{lifecycleItem}{t4}</>;
      $[10] = lifecycleItem;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  let t4;
  if ($[12] !== context || $[13] !== loads || $[14] !== push) {
    let t5;
    if ($[16] !== context || $[17] !== push) {
      t5 = load => <CommandItem key={load.id} keywords={[load.id.toString(), load.company?.title ?? "", context.search]} onSelect={() => {
        context.close();
        push(`/loads/${load.id}/overview`);
      }} value={`load-${load.id}-${load.company?.title ?? ""}`}><LoadResultRow load={load} /></CommandItem>;
      $[16] = context;
      $[17] = push;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    t4 = loads.map(t5);
    $[12] = context;
    $[13] = loads;
    $[14] = push;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[19] !== lifecycleItem || $[20] !== t4) {
    t5 = <>{lifecycleItem}{t4}</>;
    $[19] = lifecycleItem;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
};